import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
   TextInput
} from "react-native";
import { Image } from "react-native";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { Colors } from "../../../globalStyles/ColorConfig";
import { BlurView } from "expo-blur";
import { authToken } from "../../../utils/config";
import FeedIcons from "../../../assets/Icons/FeedIcons";
import ModalComponent from "../../ModalComponent";
import {
  likeEdit,
  pickupGenerater,
} from "../../../services/MatchMaker/matchMakerServices";
// import { TextInput } from "react-native-gesture-handler";

interface LikeModalProps {
  isDialog?: boolean;
  isVisible: boolean;
  toggleModal: () => void;
  likedImage: any;
  likeType: any;
  targetId: any;
  experienceId: any;
  setMatchModalVisible: any;
  matchModalVisible: any;
  setsShowLikeModalVisible: any;
  handleLikeNextProfile: any;
}

export default function LikeModal({
  isDialog = false,
  isVisible,
  toggleModal,
  likedImage,
  likeType,
  targetId,
  experienceId,
  setMatchModalVisible,
  matchModalVisible,
  setsShowLikeModalVisible,
  handleLikeNextProfile,
}: LikeModalProps) {
  const [response, setResponse] = useState([]);
  const [selectedPickupLine, setSelectedPickupLine] = useState("");
  const [isButtonActive, setIsButtonActive] = useState(false);

  const postData = async () => {
    try {
      const requestBody = {
        // experienceDetails: "Helicopter Tour in Bangkok",
      };

      const response = await pickupGenerater(JSON.stringify(requestBody));

      const data = response;
      console.log("pickup line",data?.data?.resultArray)

      setResponse(data?.data?.resultArray  );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    postData();
  }, []);

  const [renderpickupLine, setrenderPickupLine] = useState(false);

  const handlePickupLinePress = (pickupLine: any) => {
    setSelectedPickupLine(pickupLine);
    setCurrentText(pickupLine);
    setIsButtonActive(true);
    // setrenderPickupLine(false);
  };

  const callLikeApi = async (payload: any) => {
    try {
      const data = await likeEdit(JSON.stringify(payload));
      console.log("data", data?.data.statusMessage);
      toggleModal();
      if (data?.data.statusMessage === "matched") {
        setMatchModalVisible(true);
        handleLikeNextProfile();
      } else if (data?.data.statusMessage === "liked") {
        handleLikeNextProfile();
      }
      return data;
    } catch (error) {
      console.error("Error updating like:", (error as Error).message);
      console.error("Detailed error:", error);
      // throw error;
    }
  };

  const openkeyboard = () => {
    setrenderPickupLine(true);
  };
  const [currentText, setCurrentText] = useState("Send them a pickup line");

  const handleSendLike = async () => {
    let payload;
    if (likeType === "experienceLike") {
      payload = {
        liked: targetId,
        experienceId: experienceId,
        pickupLine: currentText,
      };
    } else {
      payload = {
        liked: targetId,
        pickupLine: currentText,
      };
    }
    setsShowLikeModalVisible(true);

    callLikeApi(payload);
  };

  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <BlurView
        intensity={20}
        style={{
          flex: 1,
          zIndex: 1,
        }}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalWrap}>
            <View style={styles.LikeModalContainer}>
              <View style={styles.BadgeLabelFlex}>
                <View style={styles.BadgeLabel}>
                  <Text
                    style={[
                      GlobalStyles.title1,
                      {
                        lineHeight: 33,
                      },
                    ]}
                  >
                    Adisorn
                  </Text>
                  <FeedIcons.VerifiedBadge />
                </View>
                <TouchableOpacity onPress={toggleModal}>
                  <FeedIcons.CloseEmpty />
                </TouchableOpacity>
              </View>
              <View>
                <View style={styles.ExperienceCard}>
                  {likeType === "experienceLike" ? (
                    <Image
                      source={{
                        uri: likedImage,
                      }}
                      style={styles.ExperienceCardImg}
                    />
                  ) : (
                    <Image
                      source={{ uri: likedImage }}
                      style={styles.ExperienceCardImg}
                    />
                  )}
                  {likeType === "experienceLike" && (
                    <View style={styles.HomeDisplayCardInfo}>
                      <View>
                        <View>
                          <View style={styles.transparentPill}>
                            <Text
                              style={[
                                GlobalStyles.bodyText,
                                {
                                  color: "white",
                                  opacity: 0.6,
                                },
                              ]}
                            >
                              Interested in
                            </Text>
                          </View>
                          <Text
                            style={[
                              GlobalStyles.title2,
                              {
                                color: "white",
                                fontFamily: "InterBold",
                                marginTop: 8,
                              },
                            ]}
                          >
                            Brunch at rooftop
                          </Text>
                        </View>
                      </View>
                    </View>
                  )}
                </View>
              </View>
              {renderpickupLine && (
                <ScrollView horizontal style={styles.pickupLines}>
                  {response?.map((item: any, index: any) => (
                    <TouchableOpacity
                      onPress={() => handlePickupLinePress(item)}
                      key={index}
                      style={styles.pickupLineTextBox}
                    >
                      <Text
                        style={[GlobalStyles.bodyTextBold, { color: "#fff" }]}
                      >
                        {item.replace(/["']/g, "")?.slice(0, 80)}...
                      </Text>
                    </TouchableOpacity>
                  ))}
                </ScrollView>
              )}
              <View style={styles.pickupLineContainer}>
                {/* <TouchableOpacity onPress={openkeyboard}>
                  <View style={styles.textSend}>
                    <Text>{currentText}</Text>
                  </View>
                </TouchableOpacity> */}
                {/* // create an input here */}
                <TextInput
                  style={styles.textSend}
                  value={currentText}
                  onChangeText={(text) => {
                    setCurrentText(text);
                    setIsButtonActive(true);
                  }}
                  onFocus={() => {
                    setrenderPickupLine(true);
                  }}
                />
                <TouchableOpacity
                  style={[
                    GlobalStyles.primaryButton,
                    {
                      backgroundColor: isButtonActive
                        ? Colors.darkGreen
                        : "gray",
                      marginTop: 8,
                    },
                  ]}
                  // disabled={!isButtonActive}
                  onPress={handleSendLike}
                >
                  <Text
                    style={[
                      GlobalStyles.ctaText,
                      {
                        color: "#FDFBF9",
                      },
                    ]}
                  >
                    Send a like
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </BlurView>
    </ModalComponent>
  );
}
const styles = StyleSheet.create({
  HomeDisplayCardImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  modalWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    height: "100%",
  },
  textSend: {
    backgroundColor: "#FDFBF9",
    borderRadius: 8,
    padding: 12,
    width: "100%",
    marginBottom: 8,
  },
  pickupLines: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    marginBottom: 8,
    // gap: 8,
  },
  pickupLineTextBox: {
    backgroundColor: "#000000",
    padding: 12,
    borderRadius: 6,
    width: 340,
    marginRight: 8,
  },
  pickupLineContainer: {
    width: "100%",
  },
  modalContainer: {
    backgroundColor: "rgba(169, 169, 169, 0.60)",
    flex: 1,
  },
  HomeDisplayCard: {
    width: "100%",
    position: "relative",
    overflow: "hidden",
    maxHeight: 450,
    marginBottom: 8,
  },
  HomeDisplayCardInfo: {
    position: "absolute",
    width: "100%",
    bottom: 0,
    padding: 16,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  BadgeLabel: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  ExperienceCardImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  transparentPill: {
    borderRadius: 50,
    paddingVertical: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  ExperienceCard: {
    width: "100%",
    height: 290,
    borderRadius: 8,
    overflow: "hidden",
    marginBottom: 20,
  },
  BadgeLabelFlex: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginBottom: 10,
    justifyContent: "space-between",
  },
  LikeModalContainer: {
    width: "100%",
    paddingHorizontal: 16,
  },
});
